<div class="filter" *ngIf="formLoaded">
  <form [formGroup]="form" (keyup.enter)="filterRows()">
    <div>
      <div class="row row-cols-auto">
        <div class="col">
          <div class="form-group">
            <label for="baureihe">{{
              "modules.data-management.table-header.series" | transloco
            }}</label>
            <ng-select
              [searchable]="true"
              [clearable]="false"
              notFoundText="{{ 'global.dropdown-not-found-text' | transloco }}"
              [hideSelected]="true"
              [items]="seriesList"
              bindLabel="brName"
              bindValue="brName"
              formControlName="baureihe"
            >
              <ng-template ng-option-tmp let-item="item" let-index="index">
                {{ item.brName }}
              </ng-template>
              <ng-template
                ng-label-tmp
                ng-option-selected
                let-item="item"
                let-index="index"
              >
                {{ item.brName }}
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label for="name">{{
              "global.SDP"
                | transloco
            }}</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control small-size"
              id="name"
              formControlName="name"
              placeholder="{{
                'modules.data-management.serien-daten.upload-list.placeholder.input-filter'
                  | transloco
              }}"
              (keyup.enter)="filterRows()"
            />
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label for="uploadDate">{{
              "modules.data-management.serien-daten.upload-list.upload-date"
                | transloco
            }}</label>

            <div class="input-group date-background-editable">
              <input
                #searchUploadDate
                class="form-control dp"
                placeholder="{{ 'global.datepicker-placeholder' | transloco }}"
                id="uploadDate"
                name="dp"
                formControlName="uploadDate"
                ngbDatepicker
                #dUpload="ngbDatepicker"
                readonly
                (click)="removeUploadDateFocus()"
              />
              <div class="input-group-append">
                <i class="dp" (click)="dUpload.toggle()" class="bi bi-calendar3"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label for="inSeriesSinceSDP">{{
              "global.productive-from"
                | transloco
            }}</label>

            <div class="input-group date-background-editable">
              <input
                #searchInSeriesSinceSDP
                class="form-control dp"
                placeholder="{{ 'global.datepicker-placeholder' | transloco }}"
                id="inSeriesSinceSDP"
                name="dp"
                formControlName="inSeriesSinceSDP"
                ngbDatepicker
                #dInSeriesSinceSDP="ngbDatepicker"
                readonly
                (click)="removeInSeriesSinceSDPFocus()"
              />
              <div class="input-group-append">
                <i class="dp" (click)="dInSeriesSinceSDP.toggle()" class="bi bi-calendar3"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label for="username">{{
              "global.user"
                | transloco
            }}</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control small-size"
              id="username"
              formControlName="username"
              placeholder="{{
                'modules.data-management.serien-daten.upload-list.placeholder.input-filter'
                  | transloco
              }}"
              (keyup.enter)="filterRows()"
            />
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label for="requirement">{{
              "modules.data-management.serien-daten.upload-list.requirement"
                | transloco
            }}</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control small-size"
              id="requirement"
              formControlName="requirement"
              placeholder="{{
                'modules.data-management.serien-daten.upload-list.placeholder.input-filter'
                  | transloco
              }}"
              (keyup.enter)="filterRows()"
            />
          </div>
        </div>

        <div class="col">
          <div class="button-area">
            <button
              type="button"
              class="btn btn-primary"
              (click)="filterRows()"
            >
              {{ "modules.data-management.filter.btn-search" | transloco }}
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              (click)="resetFilteredRows()"
            >
              {{ "modules.data-management.filter.btn-reset" | transloco }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
